import { useBoolean } from '@chakra-ui/react';
import React from 'react';
import FileViewer from '../../../components/pdf_viewer/FileViewer';
import { EyeAvatarIcon } from '../../../constants/IconData';
import { useAuditReportAttachment } from '../../../components/pdf_viewer/AuditReportViewer';
import { getDocumentViewerPath } from '../../../components/pdf_viewer/documentViewer.utils';

function FileViewAction({ auditUpload, chart_id=null }) {
  const [isFileOpen, ifoState] = useBoolean(false);
  const resourceId = auditUpload?.id || chart_id;
  const reportChartId = chart_id || auditUpload?.upload_id || resourceId;
  const { attachment } = useAuditReportAttachment({
    chartId: isFileOpen ? reportChartId : null,
  });

  return (
    <>
      <EyeAvatarIcon style={{ cursor: 'pointer' }} onClick={ifoState.on} />
      <FileViewer
        isOpen={isFileOpen}
        currentFile={auditUpload.file_obj}
        attachments={[
          ...(auditUpload?.attachments || []),
          ...(reportChartId && attachment ? [attachment] : [])
        ]}
        viewerPath={getDocumentViewerPath({ chartId: resourceId })}
        chartId={auditUpload?.upload_id || auditUpload?.file_id || resourceId}
        onClose={ifoState.off}
      />
    </>
  );
}

export default FileViewAction;
